import React from 'react';
import Box from '@mui/material/Box';

const tones = {
    ok: {
        background: 'var(--ok-soft)',
        color: 'var(--ok)',
        border: '1px solid #C8E5D8',
    },
    danger: {
        background: 'var(--danger-soft)',
        color: 'var(--danger)',
        border: '1px solid #EFCFD5',
    },
    warn: {
        background: 'var(--warn-soft)',
        color: 'var(--warn)',
        border: '1px solid #F0DCBB',
    },
    acc: {
        background: 'var(--accent-soft)',
        color: 'var(--accent-ink)',
        border: '1px solid var(--accent-line)',
    },
    mono: {
        background: 'var(--surface-2)',
        color: 'var(--muted)',
        border: '1px solid var(--line-2)',
        fontFamily: 'var(--mono)',
        fontSize: 10.5,
        letterSpacing: '0.01em',
    },
    default: {
        background: 'var(--surface-2)',
        color: 'var(--muted)',
        border: '1px solid var(--line-2)',
    },
};

const StatusChip = ({ tone = 'default', dot, children, label, sx }) => {
    const style = tones[tone] || tones.default;
    return (
        <Box
            component="span"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '5px',
                height: 19,
                px: '7px',
                borderRadius: '4px',
                fontSize: 11,
                fontWeight: 500,
                whiteSpace: 'nowrap',
                width: 'auto',
                flex: 'none',
                maxWidth: '100%',
                ...style,
                ...sx,
            }}
        >
            {dot && (
                <Box
                    component="span"
                    sx={{
                        width: 6,
                        height: 6,
                        borderRadius: '50%',
                        backgroundColor: 'currentColor',
                        flex: 'none',
                    }}
                />
            )}
            {label || children}
        </Box>
    );
};

export default StatusChip;
